import { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { CheckCircle2, Clock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { CreditsDisplay } from "@/components/CreditsDisplay";
import { useAuth } from "@/hooks/useAuth";

export default function Welcome() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [seconds, setSeconds] = useState(10);

  useEffect(() => {
    const timer = setInterval(() => {
      setSeconds((s) => s - 1);
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    if (seconds <= 0) {
      navigate("/");
    }
  }, [seconds, navigate]);

  const skipNow = () => navigate("/");

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4">
      <div className="w-full max-w-xl text-center space-y-6">
        <div className="flex justify-center">
          <CheckCircle2 className="w-12 h-12 text-green-600" />
        </div>
        <h1 className="text-3xl font-bold">Welcome{user?.email ? `, ${user.email.split('@')[0]}` : ""}!</h1>
        <p className="text-muted-foreground">
          You're all set. Here are your current credits and quick actions to get started.
        </p>

        <div className="flex items-center justify-center">
          <CreditsDisplay />
        </div>

        <div className="flex items-center justify-center gap-3 pt-2">
          <Button asChild>
            <Link to="/">Start Now</Link>
          </Button>
          <Button variant="secondary" asChild>
            <Link to="/pricing">Upgrade</Link>
          </Button>
        </div>

        <div className="flex items-center justify-center gap-2 text-sm text-muted-foreground pt-4">
          <Clock className="w-4 h-4" />
          <span>Redirecting to Home in {seconds}s</span>
          <button onClick={skipNow} className="underline hover:no-underline">
            Skip now
          </button>
        </div>
      </div>
    </div>
  );
}